<app-action-user #userMenu />

@if (isMobile()) {
  <mat-toolbar class="shell__topbar" role="banner">
    <button type="button" matIconButton aria-label="Abrir menu" [attr.aria-expanded]="drawerOpened()" (click)="openDrawer()">
      <mat-icon>menu</mat-icon>
    </button>

    <span class="shell__topbar-spacer"></span>

    <a class="shell__topbar-logo" routerLink="/home" aria-label="Ir para Início">
      <img ngSrc="assets/images/logo-wordmark.svg" alt="LeadGen" width="784" height="323" priority />
    </a>

    <span class="shell__topbar-spacer"></span>

    <button type="button" matIconButton aria-label="Abrir menu do usuário" [matMenuTriggerFor]="userMenu.menu()">
      <mat-icon>account_circle</mat-icon>
    </button>
  </mat-toolbar>
}

<mat-sidenav-container class="shell" [autosize]="true">
  <mat-sidenav
    class="shell__nav"
    [class.shell__nav--rail]="railMode()"
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="isMobile() ? drawerOpened() : true"
    (closedStart)="closeDrawer()"
  >
    <div class="shell__nav-inner stack">
      @if (!isMobile()) {
        <div class="shell__nav-top">
          <button
            type="button"
            matIconButton
            aria-label="Alternar largura do menu"
            [attr.aria-expanded]="!collapsed()"
            [matTooltip]="collapsed() ? 'Expandir menu' : 'Recolher menu'"
            [matTooltipDisabled]="!railMode()"
            matTooltipPosition="right"
            (click)="toggleCollapsed()"
          >
            <mat-icon>menu</mat-icon>
          </button>

          <a class="shell__nav-logo" routerLink="/home" aria-label="Ir para Início">
            @if (railMode()) {
              <img class="shell-nav__mark" ngSrc="assets/images/logo-mark.svg" alt="LeadGen" width="306" height="323" priority />
            } @else {
              <img ngSrc="assets/images/logo-wordmark.svg" alt="LeadGen" width="784" height="323" priority />
            }
          </a>
        </div>
      }

      <mat-nav-list aria-label="Navegação principal">
        <ul class="shell__nav-items stack">
          @for (entry of navEntries(); track entry.label) {
            <li>
              @switch (entry.kind) {
                @case ('link') {
                  <a
                    mat-list-item
                    class="shell__nav-item"
                    [routerLink]="entry.route"
                    routerLinkActive
                    #linkActive="routerLinkActive"
                    [routerLinkActiveOptions]="{ exact: false }"
                    [activated]="linkActive.isActive"
                    [class.shell__nav-item--current]="linkActive.isActive"
                    ariaCurrentWhenActive="page"
                    [attr.aria-label]="railMode() ? entry.label : null"
                    [matTooltip]="entry.label"
                    [matTooltipDisabled]="!railMode()"
                    matTooltipPosition="right"
                    (click)="closeDrawer()"
                  >
                    <mat-icon matListItemIcon>{{ entry.icon }}</mat-icon>
                    <span class="shell-nav__label" [class.cdk-visually-hidden]="railMode()">{{ entry.label }}</span>
                  </a>
                }
                @case ('group') {
                  @let isGroupActive = activeGroupIds().has(entry.id);
                  @let isGroupExpanded = expandedGroupIds().has(entry.id);
                  @if (railMode()) {
                    <button
                      type="button"
                      mat-list-item
                      class="shell__nav-item shell__nav-group-trigger"
                      [activated]="isGroupActive"
                      [class.shell__nav-item--current]="isGroupActive"
                      [attr.aria-label]="entry.label"
                      [matMenuTriggerFor]="groupMenu"
                      [matTooltip]="entry.label"
                      matTooltipPosition="right"
                    >
                      <mat-icon matListItemIcon>{{ entry.icon }}</mat-icon>
                      <span class="shell-nav__label cdk-visually-hidden">{{ entry.label }}</span>
                    </button>

                    <mat-menu #groupMenu="matMenu" [aria-label]="entry.label">
                      @for (child of entry.children; track child.route) {
                        <a mat-menu-item [routerLink]="child.route" routerLinkActive="is-active" ariaCurrentWhenActive="page">
                          <mat-icon>{{ child.icon }}</mat-icon>
                          <span>{{ child.label }}</span>
                        </a>
                      }
                    </mat-menu>
                  } @else {
                    <button
                      type="button"
                      mat-list-item
                      class="shell__nav-item shell__nav-group-trigger"
                      [activated]="isGroupActive && !isGroupExpanded"
                      [class.shell__nav-item--current]="isGroupActive && !isGroupExpanded"
                      [attr.aria-expanded]="isGroupExpanded"
                      [attr.aria-controls]="entry.id"
                      (click)="toggleGroup(entry.id)"
                    >
                      <mat-icon matListItemIcon>{{ entry.icon }}</mat-icon>
                      <span class="shell-nav__label">{{ entry.label }}</span>
                      <span matListItemMeta><mat-icon class="shell__nav-group-chevron">expand_more</mat-icon></span>
                    </button>

                    <ul class="shell__nav-children" [id]="entry.id" [hidden]="!isGroupExpanded">
                      @for (child of entry.children; track child.route) {
                        <li class="shell__nav-children-item">
                          <a
                            mat-list-item
                            class="shell__nav-item shell__nav-child"
                            [routerLink]="child.route"
                            routerLinkActive
                            #childActive="routerLinkActive"
                            [routerLinkActiveOptions]="{ exact: false }"
                            [activated]="childActive.isActive"
                            [class.shell__nav-item--current]="childActive.isActive"
                            ariaCurrentWhenActive="page"
                            (click)="closeDrawer()"
                          >
                            <mat-icon matListItemIcon>{{ child.icon }}</mat-icon>
                            <span class="shell__nav-child-label">{{ child.label }}</span>
                          </a>
                        </li>
                      }
                    </ul>
                  }
                }
              }
            </li>
          }
        </ul>
      </mat-nav-list>

      <div class="shell__nav-spacer"></div>

      <button
        type="button"
        class="shell__nav-user"
        aria-label="Abrir menu do usuário"
        [matMenuTriggerFor]="userMenu.menu()"
        [matTooltip]="userName()"
        [matTooltipDisabled]="!railMode()"
        matTooltipPosition="right"
      >
        <span class="avatar" aria-hidden="true">{{ userInitials() }}</span>
        <span class="shell-nav__label shell__nav-user-text" [class.cdk-visually-hidden]="railMode()">
          <span class="shell__nav-user-name text-truncate">{{ userName() }}</span>
          <span class="shell__nav-user-company text-truncate">{{ businessName() }}</span>
        </span>
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="shell__content">
    @if (hasPending()) {
      <div class="shell__loading-bar">
        <mat-progress-bar mode="indeterminate" aria-label="Carregando" />
      </div>
    }
    <router-outlet />
  </mat-sidenav-content>
</mat-sidenav-container>
